export enum ECallbackWidgetPlacement {
  Head = 'head',
  HouseGallery = 'house-gallery',
  Contacts = 'contacts',
  Feedback = 'feedback',
}
